import _ from 'underscore';
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import PersonCard from 'components/cards/entities/PersonCard';
import Section from 'components/Section';
import ShowMore from 'components/cards/ShowMore';
import OffsetSlider from 'components/sliders/OffsetSlider';
import Tabs from 'components/Tabs';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

import styles from '../styles.module.scss';

const Persons = ({ blocks, subtitle }) => {
	const tabs = useMemo(
		() =>
			_(blocks.personRubrics).map(({ path, title }) => ({
				title,
				name: path,
				entities: blocks[`${path}/persons`]
			})),
		[blocks]
	);

	const [tab, setTab] = useState(tabs?.[0].name);
	const activeTabData = _(tabs).findWhere({ name: tab }).entities;

	const tabsSliderParams = useMemo(
		() => ({
			slidesOffsetBefore: 8,
			slidesOffsetAfter: 8,
			breakpoints: {
				[`${SCREEN_BREAKPOINTS.mobileLarge}`]: {
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0
				}
			}
		}),
		[]
	);

	return (
		<Section
			title="Биографии"
			titleSize="medium"
			align="center"
			subtitle={subtitle}
		>
			<Container gutter="noMobile">
				<Tabs
					className={styles.tabs}
					list={tabs}
					active={tab}
					onClick={setTab}
					sliderParams={tabsSliderParams}
				/>
			</Container>
			<OffsetSlider key={tab}>
				{_(activeTabData).map((person) => (
					<PersonCard
						key={person._id}
						entity={person}
						typeWidth="landingPortrait"
					/>
				))}
				<ShowMore
					url={`/${tab}/persons`}
					title="Все биографии"
					type="cardPortrait"
				/>
			</OffsetSlider>
		</Section>
	);
};

Persons.propTypes = {
	blocks: PropTypes.object.isRequired,
	subtitle: PropTypes.string.isRequired
};

export default Persons;
